import {httpCall, httpMethod} from "../../service";

export function loadDatabases () {
	return httpCall( httpMethod.GET, `/mobileagent/db-list` )
}

export function downloadDatabaseById (id: number) {
	return httpCall( httpMethod.GET, `/mobileagent/db/` + id )
}

export function deleteDatabaseById (id: number) {
	return httpCall( httpMethod.DELETE, `/mobileagent/db/` + id )
}
